export const content = {
  urdu: {
    // Header
    home: "ہوم",
    prayerTimes: "اوقات نماز",
    prayerGuide: "طریقہ نماز",
    dailyDuas: "روزانہ دعائیں",
    hadiths: "احادیث",
    quranVerses: "آیات قرآن",
    about: "تعارف",

    // Hero Section
    welcome: "السلام علیکم",
    welcomeSub: "خوش آمدید اسلامی گائیڈ میں",
    welcomeDesc: "آپ کا مکمل اسلامی ساتھی - نماز، دعائیں، قرآن اور مزید",

    // Prayer Widget
    prayerTimesTitle: "کراچی کے اوقات نماز",
    fajr: "فجر",
    dhuhr: "ظہر",
    asr: "عصر",
    maghrib: "مغرب",
    isha: "عشاء",
    azanTime: "اذان کا وقت",
    prayerTime: "نماز کا وقت",

    // 5 Pillars
    pillarsTitle: "اسلام کے پانچ ستون",
    shahada: "توحید",
    shahadaDesc: "لا الہ الا اللہ محمد رسول اللہ",
    salah: "نماز",
    salahDesc: "دن میں پانچ وقت کی نماز",
    zakat: "زکوٰۃ",
    zakatDesc: "مال کی پاکیزگی اور غریبوں کا حق",
    sawm: "روزہ",
    sawmDesc: "رمضان کے مہینے میں روزے",
    hajj: "حج",
    hajjDesc: "استطاعت رکھنے والوں پر فرض",

    // About Islam
    aboutIslamTitle: "اسلام کا تعارف",
    aboutIslamDesc:
      "اسلام امن و سلامتی کا دین ہے۔ یہ دین فطرت ہے جو اللہ تعالیٰ نے تمام انسانوں کے لیے پسند فرمایا۔ قرآن پاک اللہ کی آخری کتاب اور حضور ﷺ آخری نبی ہیں۔",

    // Footer
    contact: "رابطہ کریں",
    email: "ای میل",
    phone: "فون نمبر",
    copyright: "جملہ حقوق محفوظ ہیں",
  },

  english: {
    // Header
    home: "Home",
    prayerTimes: "Prayer Times",
    prayerGuide: "Prayer Guide",
    dailyDuas: "Daily Duas",
    hadiths: "Hadiths",
    quranVerses: "Quran Verses",
    about: "About",

    // Hero Section
    welcome: "Assalamu Alaikum",
    welcomeSub: "Welcome to Islamic Guide",
    welcomeDesc: "Your Complete Islamic Companion - Prayer, Duas, Quran & More",

    // Prayer Widget
    prayerTimesTitle: "Karachi Prayer Times",
    fajr: "Fajr",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    azanTime: "Azan Time",
    prayerTime: "Prayer Time",

    // 5 Pillars
    pillarsTitle: "Five Pillars of Islam",
    shahada: "Shahada",
    shahadaDesc:
      "There is no god but Allah, Muhammad is the Messenger of Allah",
    salah: "Salah",
    salahDesc: "Five daily prayers",
    zakat: "Zakat",
    zakatDesc: "Charity and purification of wealth",
    sawm: "Sawm",
    sawmDesc: "Fasting during Ramadan",
    hajj: "Hajj",
    hajjDesc: "Pilgrimage to Makkah",

    // About Islam
    aboutIslamTitle: "About Islam",
    aboutIslamDesc:
      "Islam is the religion of peace and submission to one God. It is a complete code of life revealed by Allah through Prophet Muhammad (PBUH). The Quran is the final revelation.",

    // Footer
    contact: "Contact Us",
    email: "Email",
    phone: "Phone",
    copyright: "All Rights Reserved",
  },
};
